module.exports = __webpack_public_path__ + "img/video.a68f94e6.svg";